/**
 * @generated SignedSource<<fdd140a58388fcf07633b1a0bd7dee54>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SkillsAndTools_userProfile$data = {
  readonly tags: ReadonlyArray<{
    readonly __typename: string;
    readonly id: string;
    readonly name: string;
    readonly role?: {
      readonly id: string;
      readonly name: string;
    };
    readonly tool?: {
      readonly id: string;
      readonly logoImage: {
        readonly uid: string;
      } | null;
      readonly name: string;
    };
  }>;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentType": "SkillsAndTools_userProfile";
};
export type SkillsAndTools_userProfile$key = {
  readonly " $data"?: SkillsAndTools_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"SkillsAndTools_userProfile">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SkillsAndTools_userProfile",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "tagContexts",
          "value": [
            "WORK_PREFERENCE",
            "PROFILE"
          ]
        },
        {
          "kind": "Literal",
          "name": "tagTypes",
          "value": [
            "ROLE_TAG",
            "TOOL_TAG"
          ]
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Role",
              "kind": "LinkedField",
              "name": "role",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "UserProfileRoleTag",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Tool",
              "kind": "LinkedField",
              "name": "tool",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ContraImage",
                  "kind": "LinkedField",
                  "name": "logoImage",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "uid",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "UserProfileToolTag",
          "abstractKey": null
        }
      ],
      "storageKey": "tags(tagContexts:[\"WORK_PREFERENCE\",\"PROFILE\"],tagTypes:[\"ROLE_TAG\",\"TOOL_TAG\"])"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};
})();

(node as any).hash = "c165ac974c10098fc38ae1a97b672160";

export default node;
